import { registerPlugin } from "@capacitor/core";

const NativeWebRTC = registerPlugin("NativeWebRTC");

export default NativeWebRTC;
